import { QueryParameters } from '@standardkit/core';

export function mapPagination(offset?: number, limit?: number): QueryParameters {
  return {
    ...(typeof offset === 'number' && { offset }),
    ...(typeof limit === 'number' && { limit }),
  };
}
